import SpendTracker from "./SpendTracker";

export default SpendTracker;